import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../../constants/breakpoints";
import { colors } from "../../../../constants/colors";

const styles = createUseStyles({
  peopleGrid: {
    margin: "24px 0 0 0",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      margin: "24px -32px",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      margin: "24px -16px",
    },
    "& .rdt_TableRow": {
      "& >div:last-child": {
        position: "relative !important",
        right: "0px",
        backgroundColor: "inherit"
      }
    },
    "& .rdt_TableCell": {
      paddingLeft: "16px",
      paddingRight: "16px",
      minWidth: "155px"
    },
    "& .rdt_TableCol": {
      paddingLeft: "16px",
      paddingRight: "16px",
      minWidth: "155px",
      whiteSpace: "nowrap"
    },
    "& .rdt_TableCol:last-child": {
      minWidth: "initial"
    },
    "& .rdt_TableCell:last-child": {
      paddingRight: "16px",
      minWidth: "initial"
    }
  },
  removeInput: {
    padding: "0 0 0 5px"
  },
  deleteActionDescription: {
    marginBottom: "8px"
  },
  deleteActionNote: {
    marginTop: "8px",
    marginBottom: "8px",
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: "500",
    color: colors.grey
  },
  link: {
    textDecoration: "none",
    color: colors.mediumGrey
  },
  cc: {
    margin: "0 0 1px 10px",
    "& path": {
      stroke: colors.paleGrey
    }
  },
  role: {
    margin: 0
  },
  tooltip: {
    "& .tooltip-inner": {
      maxWidth: "unset !important",
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: "600",
      padding: "8px 12px",
      textAlign:"start",
      borderRadius: "8px",
    },
    "& .tooltip-arrow": {
      display: "none"
    }
  },

});


export default styles;
